import * as React from 'react';
import classNames from 'classnames';
import ABSUnLogin from './ABSUnLogin';
import { withRouter } from 'dva/router';
import { SHOW_CHRIS_HAT } from '../../utils/constant';
import './index.less';

const logo = require('../../assets/images/logo.png');
const ChristmasHat = require('../../assets/images/hat.png');
class ABSRegisterHeader extends React.Component<any, any> {
  render() {
    const { className } = this.props;
    const classes = classNames('abs-register-header', className);

    return (
      <div className={classes}>
        <div className="abs-header-logo">
          <a href="/">
            {SHOW_CHRIS_HAT && <img className="abs-Christmas-hat" src={ChristmasHat} />}
            <img className="abs-header-logo-img" src={logo} />
          </a>
        </div>
        <div className="abs-header-right">
          <ABSUnLogin />
        </div>
      </div>
    );
  }
}

export default withRouter(ABSRegisterHeader);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSRegisterHeader/index.tsx